import React from 'react';
import CustomerLayout from '../CustomerLayout';
import OverviewTab from './OverviewTab';

const CustomerDashboard = () => {
  return (
    <CustomerLayout>
      <div className="p-6">
        <OverviewTab />
      </div>
    </CustomerLayout>
  );
};

export default CustomerDashboard;
